import React, { useContext, useEffect, useState } from "react";
import ajaxProduct from "../../util/remote/ajaxProduct";
import AppContainer from "../../Components/Structure/AppContainer";
import Loader from "../../Components/Common/Loader";
import ClientContext from "../../Context/ClientContext";
import { Toaster, toast } from "react-hot-toast";
import "jspdf-autotable";
import TableHeader from "../../Components/Common/TableHeader";
import useStateCallback from "../../util/customHooks/useStateCallback";
import { Link, useParams } from "react-router-dom";
import ListInventoryForClient from "./ListInventoryForClient";
function ListInventory() {
  const { StoreID, store_name } = useParams();
  const [inventoryList, setInventoryList] = useState(false);
  const [loading, setLoading] = useState(false);
  const [client, setClient] = useState("");
  const { clientList } = useContext(ClientContext);
  const [modalDetails, SetModalDetails] = useStateCallback(false);
  const [modal, setModal] = useStateCallback(false);
  const handleModal = (e, item) => {
    setModal(false, () =>
      setModal(
        <ListInventoryForClient
          product={item.product_id}
          productName={item.product_name}
          clientName={
            Array.isArray(clientList)
              ? clientList.find((c) => c.client_id === client)?.name
              : ""
          }
          client={client ?? ""}
          storeID={StoreID}
          isOpen={true}
        />,
      ),
    );
  };
  const getProductInventory = async () => {
    let data = {
      storeID: StoreID,
    };
    // console.log(to_date);
    setLoading(true);
    const server_response = await ajaxProduct.fetchInventoryPerClient(data);
    setLoading(false);
    if (server_response.status === "OK") {
      setInventoryList(server_response.details);
    } else {
      setInventoryList("");
    }
  };
  useEffect(() => {
    getProductInventory();
  }, [StoreID]);
  return (
    <AppContainer title={` Inventory  ${store_name}`}>
      <Toaster position="top-center" reverseOrder={false} />
      {modal}
      <div className="card custom-card">
        <div className="card-body">
          <TableHeader title={` Inventory  ${store_name}`} />
          <div className="table-responsive">
            {loading && <Loader />}
            <table className="table table-striped table-bordered">
              <thead>
                <th>#</th>
                <th>Product Name</th>
                <th>Quantity In</th>
                <th>Quantity Out</th>
                <th>closing balance</th>
                <th>Actions</th>
              </thead>
              <tbody>
                {Array.isArray(inventoryList) ? (
                  inventoryList.map((item, key) => (
                    <tr key={key}>
                      <td>{key + 1}</td>
                      <td>{item.product_name}</td>
                      <td>{item.qty_in.qty_in_c}</td>
                      <td>{item.qty_out.qty_out_c}</td>
                      <td>{item.balance.balance_c}</td>
                      <td>
                        <Link
                          className="btn btn-sm btn-info mr-2"
                          href="#"
                          onClick={(e) => handleModal(e, item)}
                        >
                          View Ins and Outs
                        </Link>
                      </td>
                    </tr>
                  ))
                ) : (
                  <p style={{ margin: "auto" }}>
                    No products found that match the selected client.
                  </p>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </AppContainer>
  );
}
export default ListInventory;